import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getAllHistoryTasksThunk } from 'components/pages/task-history/thunk/taskHistoryThunk';
import { PAGINATION } from 'utils/constants';

const _paginateDefault: Pagination = {
    page: 1,
    per_page: PAGINATION.LIMIT_PER_PAGE,
    total: 0,
    total_pages: 0,
};

const initialState: IHistoryTaskState = {
    dataTable: [],
    paginateMetaData: _paginateDefault,
    filter: '',
    sort: {
        ascending: false,
        fieldName: '',
        sortColumn: -1,
    },
    formSearch: undefined,
    getKeywords: [],
};

const reducers = {
    setDataTable: (state: IHistoryTaskState, action: PayloadAction<ITaskHistory[]>) => {
        state.dataTable = action.payload;
    },
    setPaginateMetaData: (state: IHistoryTaskState, action: PayloadAction<Pagination>) => {
        state.paginateMetaData = action.payload;
    },
    setFilter: (state: IHistoryTaskState, action: PayloadAction<string | any>) => {
        state.filter = action.payload;
    },
    setSort: (state: IHistoryTaskState, action: PayloadAction<SortState | undefined>) => {
        state.sort = action.payload;
    },
    setFormSearch: (state: IHistoryTaskState, action: PayloadAction<ITaskHistorySearch>) => {
        state.formSearch = action.payload;
    },
    setKeywords: (state: IHistoryTaskState, action: PayloadAction<string[]>) => {
        state.getKeywords = action.payload;
    },
    resetTaskHistoryState: () => initialState,
};

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers,
    extraReducers: (builder) => {
        builder.addCase(getAllHistoryTasksThunk.fulfilled, (state, action) => {
            state.dataTable = action.payload.data ?? [];
            state.paginateMetaData = action.payload.pagination || _paginateDefault;
        });
    },
});

export const {
    setKeywords,
    setDataTable,
    setPaginateMetaData,
    setFilter,
    setSort,
    resetTaskHistoryState,
    setFormSearch,
} = userSlice.actions;

export default userSlice.reducer;
